import React, { Component, Fragment } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import SocialLinksGroup from './SocialLinksGroup';

import './index.css';

class ReferralCode extends Component {
  constructor(props) {
    super(props);
    this.state = { copied: false };
  }

  copyText = () => this.setState({ copied: true }, () => setTimeout(() => this.setState({ copied: false }), 2000));

  render() {
    const { referralUrl } = this.props;
    return (
      <Fragment>
        <div className="referral__copy-group">
          <h4 className="text-center">Share your referral link with a friend!</h4>
          <CopyToClipboard onCopy={this.copyText} text={referralUrl}>
            <input className="referral__input" value={referralUrl} readOnly />
          </CopyToClipboard>
          <CopyToClipboard onCopy={this.copyText} text={referralUrl}>
            <button id="copy-btn" className="referral__copy-btn">
              {this.state.copied ? 'Copied!' : 'Copy'}
            </button>
          </CopyToClipboard>
        </div>
        <SocialLinksGroup url={referralUrl} />
      </Fragment>
    );
  }
}

export default ReferralCode;



// WEBPACK FOOTER //
// ./src/components/Referral/ReferralCode.js